var Product = /** @class */ (function () {
    function Product(products, changeview, defaultQuantity) {
        if (defaultQuantity === void 0) { defaultQuantity = 0; }
        this.currentProduct = undefined;
        this.changeview = undefined;
        /**
         * 商品数量
         */
        this.defaultQuantity = 1;
        this._quantity = 1;
        this.products = products;
        this.changeview = changeview;
        this.defaultQuantity = defaultQuantity;
        // 初始化商品对象
        this.init();
        console.log("this.products", this.products);
    }
    Object.defineProperty(Product.prototype, "quantity", {
        get: function () {
            return this._quantity;
        },
        set: function (value) {
            if (this.currentProduct.discounts.length > 0) {
                var currentRatio = 1;
                var showRatio = '0%';
                for (var index = 0; index < this.currentProduct.discounts.length; index++) {
                    var item = this.currentProduct.discounts[index];
                    var nextItem = this.currentProduct.discounts[index + 1];
                    if (value >= item.amount && (nextItem === undefined || value < nextItem.amount)) {
                        currentRatio = item.ratio;
                        showRatio = item.showRatio;
                        break;
                    }
                }
                this.currentProduct.showPrice = this.currentProduct.price * currentRatio;
                this.currentProduct.showRatio = showRatio;
            }
            this._quantity = value;
            this.changeview && this.changeview.changeQuantity(this.currentProduct.showPrice, this.currentProduct.showRatio, this.currentProduct);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 查找商品
     */
    Product.prototype.find = function (pid) {
        var product = this.products.find(function (p) { return p.id === pid; });
        this.currentProduct = product;
        this.quantity = this.defaultQuantity;
        this.changeview && this.changeview.show(product);
        return product;
    };
    /***
     * 初始化
     */
    Product.prototype.init = function () {
        this.products = this.products.map(function (p) {
            p["discounts"] = [{
                    amount: 0,
                    ratio: 1,
                    showRatio: "0%"
                }];
            if (p.shopifyPriceStringsDiscounts && p.shopifyPriceStringsDiscounts.length > 0) {
                p.shopifyPriceStringsDiscounts.forEach(function (s) {
                    var discount = s.split("==");
                    p["discounts"].push({
                        amount: Number(discount[0]),
                        ratio: (100 - Number(discount[1])) / 100,
                        showRatio: "".concat(discount[1], "%")
                    });
                });
            }
            p["amount"] = p.discounts[p.discounts.length - 1].amount;
            return p;
        });
        this.currentProduct = this.products[0];
        this.currentProduct.showRatio = this.currentProduct.discounts[0].showRatio || "0%";
        this.changeview && this.changeview.show(this.currentProduct);
    };
    return Product;
}());
console.log("kaiadadas");
